import axiosInstance from "../../services/axiosInstance";

export const createGateway = async (gatewayData: any) => {
    try {
        const response = await axiosInstance.post('/create-gateway', gatewayData);
        console.log("Gateway created successfully:", response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAllGateways = async () => {
    try {
        const response = await axiosInstance.get('/gateways');
        return response.data;
    } catch (error) {
        throw error;
    }
};
    